/**
 * Beyond Card Types CTA (Call to Action) enums based on Docecbo learning types to
 * display buttons for unsigned in or not logged in users
 * See related enrollment message enums
 */
export enum CardTypeCallToActions {
  ENROLL = 'Enroll', // User must be logged in to enroll
  UNENROLL = 'Unenroll', // User must be logged in to unenroll
  LEARN_MORE = 'Learn More', // Subscription or Learning Plan learning type
  SIGN_IN = 'Sign In', // E-Learning learning type
  SUBSCRIPTION_REQUIRED = 'Subscription Required', // User must be logged in and not have this in their active subscriptions
  REQUEST_A_VOUCHER = 'Request a Voucher', // Certification Exam learning type
  REQUEST_A_QUOTE = 'Request a Quote', // Request a Quote - Eloqua Marketing Modal
  CONTACT_SALES = 'Contact Sales', // Contact Beyond
  VIEW_ENROLLMENT_OPTIONS = 'View Enrollment Options', // Course Non-ELearning leanring type
  VIEW_ENROLLMENT_MULTIPLE_OPTIONS = 'View Enrollment Options >', // Course Non-ELearning leanring type
  SOLD_OUT = 'Sold Out', // Sesssion cannot be enrolled and are sold out
  CONTACT_US = 'Contact Us', // Contact Us in subscription details
  EXPLORE_CATALOG = 'Explore Catalog', // Catalog explore in subscription details
  GET_STARTED = 'Start for Free',
  VIEW_STUDY_GUIDE = 'View Study Guide',
}
